import script from "./Cart.vue?vue&type=script&setup=true&lang=js"
export * from "./Cart.vue?vue&type=script&setup=true&lang=js"

import "./Cart.vue?vue&type=style&index=0&id=87d0024e&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87d0024e"]])

export default __exports__